import { BrowserRouter as Router } from "react-router-dom";
import { Preload } from "../components/Preload";
import { useAuth } from "../hooks/useAuth";
import { AuthRoutes } from "./AuthRoutes";
import { RootRoutes } from "./RootRoutes";

export function Routes() {
  const { user, loading } = useAuth();

  return (
    <Preload loading={loading}>
      <Router>{user ? <RootRoutes /> : <AuthRoutes />}</Router>
    </Preload>
  );
}
